const ORDER_ROW_TYPE_META = {
  STATIC_PRINTABLE_FILE: { icon: "🖨️", label: "Statisk mall" },
  DYNAMIC_PRINTABLE_FILE: { icon: "🧩", label: "Dynamisk mall" },
  ONLINE_DESIGNER_FILE: { icon: "🎨", label: "Online designer" },
  ONE_STREAM_PRODUCED_FILE: { icon: "⚙️", label: "OneStream produktion" },
  STOCK_PRODUCT: { icon: "📦", label: "Lagerprodukt" },
  PROPERTY_PRODUCT: { icon: "🏷️", label: "Egenskapsprodukt" },
  FREE_TEXT_PRODUCT: { icon: "✏️", label: "Fritextprodukt" },
};

export default ORDER_ROW_TYPE_META;